export default "__VITE_ASSET__B_L8coBA__"